import { CTBase } from '@ctsolution/ct-base';

export class Task_Lead extends CTBase<Task_Lead> {

  Oid?: number;
  InvoiceVAT: number | null = null;
  StartDate: Date | null = null;
  HiredDate: Date | null = null;
  CreateAt: Date | null = null;
  UpdateAt: Date | null = null;

  State: { Oid: number, Code?: string, Description?: string } | null = null;
  Task: { Oid: number, Name?: string } | null = null;
  Lead: { Oid: number, Name?: string } | null = null;

  CreatedBy: { Oid: number } | null = null;
  UpdatedBy: { Oid: number } | null = null;

  private constructor();
  private constructor(model?: Task_Lead);
  private constructor(model?: Task_Lead) {
    super();
    if (model) this.getClass(model);
  }

  public static create = (model?: Task_Lead) => new Task_Lead(model);

  setOid(value?: number) {
    this.Oid = value;
    return this;
  }

  setInvoiceVAT(value: number | null) {
    this.InvoiceVAT = value;
    return this;
  }

  setStartDate(value: Date | null) {
    this.StartDate = value;
    return this;
  }

  setHiredDate(value: Date | null) {
    this.HiredDate = value;
    return this;
  }

  setStateOid(value: number | null) {
    this.State = value !== null ? { Oid: value } : null;
    return this;
  }

  setTaskOid(value: number | null) {
    this.Task = value !== null ? { Oid: value } : null;
    return this;
  }

  setLeadOid(value: number | null) {
    this.Lead = value !== null ? { Oid: value } : null;
    return this;
  }

  setCreatedByOid(value: number | null) {
    this.CreatedBy = value !== null ? { Oid: value } : null;
    return this;
  }

  setUpdatedByOid(value: number | null) {
    this.UpdatedBy = value !== null ? { Oid: value } : null;
    return this;
  }
}